/**
 * @flow
 * @relayHash cd7a996305a3939160375297a60825d0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ApplicabilityType = "LOCAL" | "LOCALIZED" | "SYSTEM" | "%future added value";
export type HomeContentQueriesDocumentsToReviewQueryVariables = {||};
export type HomeContentQueriesDocumentsToReviewQueryResponse = {|
  +documentsToReviewHome: ?{|
    +documents: ?$ReadOnlyArray<?{|
      +pk: ?number,
      +name: string,
      +bloc: {|
        +pk: ?number,
        +name: string,
      |},
      +applicabilityType: ?ApplicabilityType,
      +category: {|
        +name: string
      |},
      +expirationDate: ?string,
      +restricted: boolean,
      +isTemplate: ?boolean,
      +systemDocumentTemplate: ?{|
        +name: ?string
      |},
      +documentsOfTemplate: ?{|
        +documents: ?$ReadOnlyArray<?{|
          +pk: ?number,
          +name: string,
          +bloc: {|
            +pk: ?number,
            +name: string,
          |},
          +applicabilityType: ?ApplicabilityType,
          +category: {|
            +name: string
          |},
          +expirationDate: ?string,
        |}>
      |},
    |}>,
    +totalCount: ?number,
    +buckets: ?any,
    +counts: ?{|
      +templateCount: ?number,
      +templateRejectedCount: ?number,
    |},
  |}
|};
export type HomeContentQueriesDocumentsToReviewQuery = {|
  variables: HomeContentQueriesDocumentsToReviewQueryVariables,
  response: HomeContentQueriesDocumentsToReviewQueryResponse,
|};
*/


/*
query HomeContentQueriesDocumentsToReviewQuery {
  documentsToReviewHome {
    documents {
      pk
      name
      bloc {
        pk
        name
        id
      }
      applicabilityType
      category {
        name
        id
      }
      expirationDate
      restricted
      isTemplate
      systemDocumentTemplate {
        name
        id
      }
      documentsOfTemplate {
        documents {
          pk
          name
          bloc {
            pk
            name
            id
          }
          applicabilityType
          category {
            name
            id
          }
          expirationDate
          id
        }
      }
      id
    }
    totalCount
    buckets
    counts {
      templateCount
      templateRejectedCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": [
    v0,
    v1
  ]
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "applicabilityType",
  "args": null,
  "storageKey": null
},
v4 = [
  v1
],
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v4
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isTemplate",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buckets",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "counts",
  "storageKey": null,
  "args": null,
  "concreteType": "DueForReviewCounts",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "templateCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "templateRejectedCount",
      "args": null,
      "storageKey": null
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "bloc",
  "storageKey": null,
  "args": null,
  "concreteType": "BlocType",
  "plural": false,
  "selections": [
    v0,
    v1,
    v12
  ]
},
v14 = [
  v1,
  v12
],
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v14
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HomeContentQueriesDocumentsToReviewQuery",
  "id": "9a1e1a41772c8020482cd059c2d4291e",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HomeContentQueriesDocumentsToReviewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReviewHome",
        "storageKey": null,
        "args": null,
        "concreteType": "DocumentsToReviewHomePageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": true,
            "selections": [
              v0,
              v1,
              v2,
              v3,
              v5,
              v6,
              v7,
              v8,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v4
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentsOfTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentsOfTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": true,
                    "selections": [
                      v0,
                      v1,
                      v2,
                      v3,
                      v5,
                      v6
                    ]
                  }
                ]
              }
            ]
          },
          v9,
          v10,
          v11
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeContentQueriesDocumentsToReviewQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentsToReviewHome",
        "storageKey": null,
        "args": null,
        "concreteType": "DocumentsToReviewHomePageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": true,
            "selections": [
              v0,
              v1,
              v13,
              v3,
              v15,
              v6,
              v7,
              v8,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "systemDocumentTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "SystemDocumentTemplateType",
                "plural": false,
                "selections": v14
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentsOfTemplate",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentsOfTemplateType",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": true,
                    "selections": [
                      v0,
                      v1,
                      v13,
                      v3,
                      v15,
                      v6,
                      v12
                    ]
                  }
                ]
              },
              v12
            ]
          },
          v9,
          v10,
          v11
        ]
      }
    ]
  }
};
})();
node.text = "query HomeContentQueriesDocumentsToReviewQuery {\n  documentsToReviewHome {\n    documents {\n      pk\n      name\n      bloc {\n        pk\n        name\n        id\n      }\n      applicabilityType\n      category {\n        name\n        id\n      }\n      expirationDate\n      restricted\n      isTemplate\n      systemDocumentTemplate {\n        name\n        id\n      }\n      documentsOfTemplate {\n        documents {\n          pk\n          name\n          bloc {\n            pk\n            name\n            id\n          }\n          applicabilityType\n          category {\n            name\n            id\n          }\n          expirationDate\n          id\n        }\n      }\n      id\n    }\n    totalCount\n    buckets\n    counts {\n      templateCount\n      templateRejectedCount\n    }\n  }\n}\n";
(node/*: any*/).hash = '6c4ea3df3a2e68f57094d471ba2a6e13';
module.exports = node;
